import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../components/UI/CustomButton';
import { privateRoutes } from '../../../configs/routes';
import { TProduct } from '../../../types/Common';
import ProductCard from '../../../components/Card/ProductCard';
import { getProducts } from '../../../apis/product';
import './exams.scss';

const ExamsSection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [examsList, setExamsList] = useState<TProduct[]>([]);

  const getExamsSectionData = () => {
    setLoading(true);
    getProducts('0')
      .then((res: any) => {
        const filterProduct = res?.products.filter((i: TProduct) => i.productId === 101);
        setExamsList(filterProduct || []);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getExamsSectionData();
  }, []);

  return (
    <Box className='mainExamsContainer'>
      <Box className='examHeader'>
        <Typography color='text.main' fontWeight='bold' fontSize='large'>
          تست های دیگر
        </Typography>
        <CustomButton
          variant='text'
          disabled
          onClick={() => navigate(`${privateRoutes.product}?tab=1`)}
        >
          <Typography color='primary.main'>دیدن همه</Typography>
        </CustomButton>
      </Box>

      <Box className='listContainer'>
        {loading ? (
          <Box width='100%' py={10} textAlign='center'>
            <CircularProgress size={26} color='primary' />
          </Box>
        ) : examsList.length === 0 ? (
          <Typography>لیست تست ها خالی می باشد</Typography>
        ) : (
          examsList?.slice(0, 8).map((item: TProduct) => (
            <Box key={item.productId} className='listItem'>
              <ProductCard product={item} />
            </Box>
          ))
        )}
      </Box>
    </Box>
  );
};

export default ExamsSection;
